// extracted by mini-css-extract-plugin
export default {"container":"FeatureLink_container__BNpJH","icon":"FeatureLink_icon__htAiS"};